import { render, staticRenderFns } from "./PreviewChanges.vue?vue&type=template&id=894a1c58&scoped=true&"
import script from "./PreviewChanges.vue?vue&type=script&lang=js&"
export * from "./PreviewChanges.vue?vue&type=script&lang=js&"
import style0 from "./PreviewChanges.vue?vue&type=style&index=0&id=894a1c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894a1c58",
  null
  
)

export default component.exports